import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const headingFont = { fontFamily: '"IBM Plex Sans", Inter, sans-serif' };

export default function PublicHeader() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const homeSection = id => pathname === '/' ? `#${id}` : `/#${id}`;

  return (
    <nav aria-label="Main navigation" className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-white/70 border-b border-black/10 backdrop-saturate-150" style={{ fontFamily: 'Inter, "IBM Plex Sans", sans-serif' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 h-14 sm:h-16 flex items-center justify-between">
        <button onClick={() => navigate('/')} className="flex items-center gap-2.5" data-testid="nav-logo">
          <div className="w-8 h-8 rounded overflow-hidden flex-shrink-0">
            <img src="/founderboard-logo.png" alt="Founderboard" className="w-full h-full object-contain" />
          </div>
          <span className="text-lg font-black tracking-tight" style={headingFont}>Founderboard</span>
        </button>
        <div className="hidden md:flex items-center gap-8 text-sm">
          <a href="/programs" className="text-black/60 hover:text-black transition-colors font-medium" aria-current={pathname === '/programs' ? 'page' : undefined}>Programs</a>
          <a href="/services" className="text-black/60 hover:text-black transition-colors font-medium" aria-current={pathname === '/services' ? 'page' : undefined}>Services</a>
          <a href={homeSection('personas')} className="text-black/60 hover:text-black transition-colors font-medium">Platform</a>
          <a href={homeSection('ai')} className="text-black/60 hover:text-black transition-colors font-medium">AI</a>
          <a href={homeSection('pricing')} data-testid="nav-pricing" className="text-black/60 hover:text-black transition-colors font-medium">Pricing</a>
          <a href={homeSection('faq')} className="text-black/60 hover:text-black transition-colors font-medium">FAQ</a>
        </div>
        <div className="flex items-center gap-3">
          <button onClick={() => navigate('/login')} data-testid="nav-login" className="text-sm font-medium text-black/70 hover:text-black hidden sm:block">Log in</button>
          <button onClick={() => navigate('/signup')} data-testid="nav-signup-btn" className="px-4 py-2 bg-black text-white text-xs uppercase tracking-[0.15em] font-bold hover:bg-black/85" style={headingFont}>Sign up</button>
        </div>
      </div>
    </nav>
  );
}
